var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-footer main-footer2 minwidth"},[_c('div',{staticClass:"blank-ft"}),_c('div',{staticClass:"copyright2"},[_c('div',{staticClass:"mx1360 tbd"},[_c('div',{staticClass:"t"},[_vm._v("@ 2025 环太湖艺术动产登记备案综合服务平台.")]),_c('div',{staticClass:"t2"},[_vm._v("Huantaihu Art Movable Asset Registry & Integrated Services Platform All rights reserved. ")])])])])
}]

export { render, staticRenderFns }